import { pro } from '@/utils/settings';
var theme = null;
if (pro == 'jnu') {
  theme = import("./jnu/index.css"); // 暨大特有的Element自定义主题
}
export default theme;